import { render } from "./NavbarComponent.vue?vue&type=template&id=13b605ff&scoped=true"
const script = {}

import "./NavbarComponent.vue?vue&type=style&index=0&id=13b605ff&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b605ff"]])

export default __exports__